import * as _ from 'lodash';
import { MeetingType } from '../../../objects/Meeting';
import './meetingFinder.less';

class MeetingFinderController {

    static get $inject() {
        return ['tromanServer'];
    }

    constructor(tromanServer) {
        this._tromanServer = tromanServer;
        this.isSearching = false;
        this.selectedMeetingId = null;
        this.selectedOrganizationId = null;
        /** @type {MeetingLookupResult[]} */
        this.meetings = null;
    }

    search() {
        this.selectedMeetingId = null;
        this.selectedMeetingChanged(null);

        if (this.date) {
            this.isSearching = true;
            this._tromanServer.Meetings.lookup({
                HighlightPersonId: this.forPersonId,
                DateFrom: new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate()),
                DateTo: new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate()),
            }).then(result => {
                this.allmeetings = _.sortBy(result, [x => x.OrganizationName, x => x.MeetingDate, x => x.MeetingTime]);
                this.filterOrganization();
            }).catch(err => {
                this.meetings = null;
                this.error = err;
            }).finally(() => {
                this.isSearching = false;
            });
        }
    }

    filterOrganization() {
        if (this.selectedOrganizationId) {
            this.meetings = _.filter(this.allmeetings, x => x.OrganizationId === this.selectedOrganizationId);
            if (this.selectedMeetingId != null) {
                if (!_.some(this.meetings, x => x.Id === this.selectedMeetingId)) {
                    this.selectedMeetingId = null;
                    this.selectedMeetingChanged(null);
                }
            }
        } else {
            this.meetings = this.allmeetings;
        }
    }

    /**
     * 
     * @param {any} changed
     */
    $onChanges(changed) {
        if (changed.date || changed.forPersonId) {
            this.search();
        }
    }

    dateChanged() {
        this.search();
    }

    organizationChanged() {
        this.filterOrganization();
    }

    selectedMeetingChanged(meeting) {
        this.meetingSelected({ value: meeting });
    }

    formatMeetingType(meeting) {
        switch (meeting.MeetingType) {
            case MeetingType.regular: return 'Ordinarie';
            case MeetingType.other: return 'Annat';
            default: return 'foo';
        }
    }
}

angular.module("tromanWeb").component('ergoMeetingFinder', {
    template: require('./meetingFinder.html'),
    bindings: {
        date: '<',
        organizationId: '<',
        forPersonId: '<',
        organizations: '<',
        meetingSelected: '&',
    },
    controller: MeetingFinderController
});

